<template>
  <v-autocomplete
      ref="input"
      class="vehicle-select"
      v-model="data"
      :search-input.sync="search"
      :label="label"
      :items="itemFiltered"
      :loading="loading"
      v-on="$listeners"
      :rules="rules"
      item-value="id"
      :item-text="v => v.name || v.vin"
      chips
      :clearable="clearable"
      :disabled="disabled"
      :multiple="multiple"
      :deletable-chips="multiple"
      no-filter
      hide-details
      hide-no-data
      @change="onSelect"
  >
    <template #item="{item, attrs, on}">
      <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
        <v-list-item-action v-if="multiple">
          <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <template v-if="item.version">
              {{ item.version.brand }} {{ item.version.model }} -
            </template>
            {{ item.registrationNumber }} ({{ item.name }})
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.vin">
            {{ item.vin }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template #selection="{item}">
      <v-chip small close v-if="multiple" @click:close="removeItem(item.id)">
        <template v-if="item.version">
          {{ item.version.brand }} {{ item.version.model }} -
        </template>
        {{ item.registrationNumber }} ({{ item.name }})
      </v-chip>
      <span v-else>
        <template v-if="item.version">
          {{ item.version.brand }} {{ item.version.model }} -
        </template>
        {{ item.registrationNumber }} ({{ item.name }})
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import VehicleRepository from "@repository/VehicleRepository";

export default {
  name: 'VehicleSelect',

  data() {
    return {
      loading: false,
      search: null,
      data: this.value,
      items: [],
    }
  },

  model: {
    prop: 'value',
  },

  props: {
    value: [String, Array],
    label: String,
    rules: Array,
    multiple: Boolean,
    disabled: Boolean,
    clearable: Boolean,
    organizationId: String,
    customerId: String,
    exclude: Array,
  },

  mounted() {
    this.loadData()
  },

  watch: {
    value(v) {
      this.data = v
    },
    data(v) {
      this.$emit('input', v)
    },
    search() {
      this.loadData()
    },
    organizationId() {
      this.loadData()
    },
    customerId() {
      this.loadData()
    },
  },


  computed: {

    itemFiltered() {
      return this.items.filter(item => {
        if(this.exclude) {
          return !this.exclude.includes(item.id)
        } else {
          return true
        }
      })
    },


  },

  methods: {
    // Emit the full selected vehicle object (single-select only) so parents can e.g. prefill a name.
    onSelect(id) {
      if (this.multiple) return
      this.$emit('selected', this.items.find(i => i.id === id) || null)
    },

    loadData() {
      this.loading = true
      VehicleRepository.search({
        search: this.search || '',
        organizationId: this.organizationId || undefined,
        customerId: this.customerId || undefined,
        limit: 30,
      }).then(response => {
        const results = response.items || response.data || response
        // Merge with existing selected items to keep them visible
        const existingIds = Array.isArray(this.data) ? this.data : (this.data ? [this.data] : [])
        const merged = [...results]
        for (const item of this.items) {
          if (existingIds.includes(item.id) && !merged.find(r => r.id === item.id)) {
            merged.push(item)
          }
        }
        this.items = merged
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    removeItem(id) {
      if (Array.isArray(this.data)) {
        this.data = this.data.filter(v => v !== id)
      }
    },
  },
}
</script>
